export const locales = {
	backBtnText: 'Retour'
};
